import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  tips,
  getRandomFromArray,
  TipType
} from "pages/loader/components/tip/data"
import Container from "ui/container/index.tsx"
import { triangle } from "assets/icons"
import "./index.scss"

export type LoaderScreenVariant = "default" | "dark"

export interface LoaderScreenProps {
  variant?: LoaderScreenVariant
  backgroundImage: string
  logo: string
  progress: number
}

const LoaderScreen: FC<LoaderScreenProps> = ({
  variant = "default",
  backgroundImage,
  logo,
  progress
}) => {
  const { t } = useTranslation()
  const [tip] = useState<TipType>(() => getRandomFromArray(tips))

  return (
    <div className={`loader-screen loader-screen--${variant} fullscreen`}>
      <img
        src={backgroundImage}
        alt="background"
        className="loader-screen__background"
      />
      <img src={logo} alt="loader logo" className="loader-screen__logo" />
      <div className="loader-screen__bar">
        <div className="loader-screen__track">
          <div style={{ height: `${progress}%` }}>
            <div className="loader-screen__value">
              <img src={triangle} alt="triangle" />
              <span>{Math.min(Math.round(progress), 100)}%</span>
              <p>{t("loading")}</p>
            </div>
          </div>
        </div>
      </div>
      <Container
        triangleTopPosLeft="calc(100% - 66px)"
        className="loader-screen__tip"
      >
        <h3 style={{ textDecoration: tip.crossed ? "line-through" : "none" }}>
          {t("tip")} <span>#{tip.number}</span>
        </h3>
        <div>{t(tip.translationKey)}</div>
      </Container>
    </div>
  )
}

export default LoaderScreen
